import React, { Fragment, useContext, useState } from 'react';
import styles from './styles.module.css';
import InstaBrain from '../../../Assets/ib_color.png';
import Correct from '../../../Assets/Correct.gif';
import { Button } from "@mui/material";
import copyToClipboard from "../../../utils/copyToClipboard";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import {
    IThirdPartyQuestionnaireContext,
    ThirdPartyQuestionnaireContext
} from "../../../Context/thirdPartyQuestionnaireContext";
import { toast } from "react-toastify";


const ThirdPartyQuestionsSubmittedSuccessfully = () => {

    const [copied, setCopied] = useState(false);

    const {userInfo } = useContext(ThirdPartyQuestionnaireContext) as IThirdPartyQuestionnaireContext;

    const handleCopy = async (userId:number, accessTokenUid:string) => {
        const textToCopy = `User ID: ${userId}\nAccess Token: ${accessTokenUid}`;
        await copyToClipboard(textToCopy, () => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        }).catch(() => {
            toast.error("Failed to copy to clipboard");
        });
    };

    return (
        <Fragment>
            <div className={styles.navbar}>
                <img
                    alt={"instabrain"}
                    src={InstaBrain}
                    className={styles.instabrainLogo}
                />
            </div>
            <div className={styles.contentOuter}>
                <img
                    alt={"success"}
                    src={Correct}
                    className={styles.correct}
                />
                <h2 className={styles.mainText}>Thank you for submitting the form!</h2>
                <h4 className={styles.subText}>Your data has been saved successfully. We will contact you shortly.</h4>
                {userInfo && <div className={styles.userInfoCtn}>
                    <p className={styles.paragraph}>
                        Meanwhile, please find the credentials below to track updates on your request.
                        <br/> These details have
                        also been sent to your registered email address.
                    </p>
                    <div className={styles.userInfoDetailsCtn}>
                        <div className={styles.userInfoTxtCtn}>
                            <p><strong>User ID:</strong> {userInfo.userId}</p>
                            <p><strong>Access Token:</strong> {userInfo.accessTokenUid}</p>
                        </div>
                        <div>
                            <Button onClick={()=>{handleCopy(userInfo.userId,userInfo.accessTokenUid)}} variant="outlined" color="primary" className={styles.copyBtn}>
                                {copied ? <CheckIcon/> : <ContentCopyIcon/>}
                                {copied ? "Copied!" : "Copy"}
                            </Button>
                        </div>
                    </div>
                </div>}
            </div>
        </Fragment>
    );
};

export default ThirdPartyQuestionsSubmittedSuccessfully;